import React, { HTMLProps } from 'react';

export const TooltipIndicator: React.FC<{} & HTMLProps<HTMLDivElement>> = ({ className, children, ...rest }) => {
    return (
        <div
            className={`${
                !!className ? className : 'bg-bnd-green'
            } w-6 h-6 rounded-full inline-flex justify-center items-center`}
            {...rest}
        >
            <div className="inline-block text-center mt-0.5 text-bnd-white-1">{children}</div>
        </div>
    );
};
